/* ============================================================
   Floral · Klaviyo subscription wiring for THC Laws forms
   Subscribes the entered email to the "State Regulatory Signups"
   Klaviyo list (id = Ydr23b) via the public client API.
   ============================================================ */
(function(){
  'use strict';
  var COMPANY_ID = 'VaSiHk';
  var LIST_ID    = 'Ydr23b';

  function attach(form){
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var input = form.querySelector('input[type="email"]');
      var btn   = form.querySelector('button[type="submit"]');
      var email = (input && input.value || '').trim();
      if(!email){ return; }
      var origLabel = btn ? btn.textContent : '';
      if(btn){ btn.textContent = 'Sending…'; btn.disabled = true; }

      var payload = {
        data: {
          type: "subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: email,
                  properties: {
                    "Signup Source": "THC Laws by State Page",
                    "Signup Page": window.location.pathname
                  }
                }
              }
            }
          },
          relationships: {
            list: { data: { type: "list", id: LIST_ID } }
          }
        }
      };

      fetch(
        "https://a.klaviyo.com/client/subscriptions/?company_id=" + COMPANY_ID,
        {
          method: "POST",
          headers: {
            "accept": "application/vnd.api+json",
            "content-type": "application/vnd.api+json",
            "revision": "2024-10-15"
          },
          body: JSON.stringify(payload)
        }
      ).then(function(r){
        if(r.status === 202 || r.status === 201 || r.status === 200){
          if(btn){ btn.textContent = 'Subscribed ✓'; }
          if(input){ input.value = ''; input.placeholder = "You're on the list"; }
          // Fire dataLayer / Klaviyo onsite event for analytics
          try {
            if(window.klaviyo){ window.klaviyo.identify({ "$email": email }); }
            if(window.dataLayer){ window.dataLayer.push({event:"thc_law_alert_signup", email_domain: email.split("@")[1]}); }
          } catch(err){ /* no-op */ }
        } else {
          return r.text().then(function(t){
            console.warn('Klaviyo subscribe failed', r.status, t);
            if(btn){ btn.textContent = 'Try again'; btn.disabled = false; }
          });
        }
      }).catch(function(err){
        console.warn('Klaviyo network error', err);
        if(btn){ btn.textContent = origLabel || 'Send me alerts'; btn.disabled = false; }
      });
    });
  }

  function init(){
    document.querySelectorAll('.flmap__alert-form').forEach(attach);
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
